import $ from 'jquery'
import { gallerySlider } from './gallery-slider'
import { instagramSlider } from './instagram-slider'
import { instagramApi } from './instagram-api'
import { imageHover } from './image-hover'
import { googleMapsLocations } from './gmaps'
import { availibilityTable } from './availibility-table'
import { floorPlan } from './floor-plan'
import { menuImages } from './menu-images';
// import { chatBotCustomization } from './chat-bot';
import { brochureDownloadForm } from './form-brochure';
import { closeSelect2 } from './select2';


$(document).ready(function() {
	gallerySlider()
	instagramSlider()
	instagramApi()
	imageHover()
	googleMapsLocations()
	availibilityTable()
	floorPlan()
	menuImages();
	// chatBotCustomization();
	brochureDownloadForm();
	closeSelect2();
});
